<template>
  <Modal
    :title="title"
    v-model="visible"
    :width="width"
    :mask-closable="false"
    :closable="closable"
    :footer-hide="footerhide"
    :styles="styles"
    :fullscreen="fullscreen"
  >
    <slot name="title" slot="header"></slot>
    <slot></slot>
    <slot name="footer" slot="footer"></slot>
  </Modal>
</template>
<script>
export default {
  name: "lms-dialog-layout",
  props: {
    title: {},
    width: {
      default: "80%",
      type: String
    },
    center: {
      default: false,
      type: Boolean
    },
    beforeClose: {
      default: done => {
        done();
      },
      type: Function
    },
    closable: {
      type: Boolean,
      default: true
    },
    footerhide: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    styles: {
      default: done => {
        return { top: "20px" };
      },
      type: Object
    }
  },
  data() {
    return {
      promise: null,
      resolve: null,
      reject: null,
      visible: false,
      confirmClose: false,
      result: {}
    };
  },
  methods: {
    open() {
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.visible = true;
      });
      return this.promise;
    },
    close(result) {
      this.confirmClose = true;
      this.result = result;
      this.visible = false;
    },
    cancel() {
      this.confirmClose = false;
      this.result = {};
      this.visible = false;
    },
    handleClose() {
      if (this.confirmClose) {
        this.resolve(this.result);
      } else {
        this.reject();
      }
    }
  },
  watch: {
    visible(n, o) {
      if (n == false) {
        this.handleClose();
      }
    }
  }
};
</script>
<style>
.n-dialog-layout .el-dialog {
  min-width: 720px;
}
</style>



// WEBPACK FOOTER //
// LmsDialog.vue?4ffbcab4